import Agent from "infrastructure/agent";
import contentDisposition from "content-disposition";
import { HeliReportMapper } from "features/planner/report/report.mappers";

import { WorkScheduleReportParametersMapper } from "features/planner/report/report.mappers";
import appService from "services/app.service";

/**
 * POB
 */
const getPOBReport = () => Agent.get(`/report/pob`);

const previewPOBReport = () => appService.openApiUrl(`/report/pob/download`);

/**
 * Heli
 */
const getHeliReport = groupId => Agent.get(`/report/heli/${groupId}`);

const sendHeliReport = heliReport =>
  Agent.post(`/report/heli`, HeliReportMapper.to(heliReport));

const downloadHeliReport = heliReport =>
  Agent.maybeRefreshToken().then(request =>
    request
      .post(`${Agent.config.apiRoot}/report/heli/download`)
      .send(HeliReportMapper.to(heliReport))
      .responseType("blob")
      .then(({ headers, body: file }) => {
        const { parameters } = contentDisposition.parse(
          headers["content-disposition"],
        );

        return [file, parameters.filename];
      }),
  );

/**
 * Work Schedule
 */
const getWorkScheduleReport = params =>
  Agent.post(`/report/schedule`, WorkScheduleReportParametersMapper.to(params));

const downloadWorkScheduleReport = params =>
  Agent.maybeRefreshToken().then(request =>
    request
      .post(`${Agent.config.apiRoot}/report/schedule/download`)
      .send(WorkScheduleReportParametersMapper.to(params))
      .responseType("blob")
      .then(({ headers, body: file }) => {
        const { parameters } = contentDisposition.parse(
          headers["content-disposition"],
        );

        return [file, parameters.filename];
      }),
  );

/**
 * Schedule Overrides
 */

const getScheduleOverridesReport = () =>
  Agent.get(`/report/schedule-overrides`);

export default {
  getPOBReport,
  getHeliReport,
  sendHeliReport,
  downloadHeliReport,
  getWorkScheduleReport,
  downloadWorkScheduleReport,
  getScheduleOverridesReport,
  previewPOBReport,
};
